import i18n from '@/i18n';
import Locale from '@/config/locale';

export default function valueByLocale(chnValue, enValue) {
  return i18n.locale === Locale.ZH_MO ? chnValue : enValue;
}
